import React, { useState } from "react";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import "react-toastify/dist/ReactToastify.css";
import "./style/ExpandableTip.css";
import "./style/HighlightPopup.css";
import "./style/CommentForm.css";

const modules = {
  toolbar: {
    container: [
      [{ header: ["1", "2", "3", "4", "5", "6"] }],
      [{ background: [] }],
      [{ color: [] }],
      ["bold", "italic", "underline", "strike"],
      [{ list: "ordered" }, { list: "bullet" }],
      [{ align: [] }],
      ["link", "image"],
    ],
  },
};

const formats = [
  "header",
  "background",
  "color",
  "bold",
  "italic",
  "underline",
  "strike",
  "list",
  "bullet",
  "align",
  "link",
  "image",
];

const CommentForm = ({ onSubmit, placeHolder, value }) => {
  const [isFormOpen, setIsFormOpen] = useState(true);
  const [input, setInput] = useState(value || "");

  const handleSubmit = (event) => {
    event.preventDefault();

    if (!input.trim()) {
      alert("You haven't entered any comment.");
      return;
    }

    onSubmit(input);
  };

  if (!isFormOpen) return null;

  const handleCancel = () => {
    setIsFormOpen(false);
    setInput("");
  };

  return (
    <form className="Tip__card" onSubmit={handleSubmit}>
      <ReactQuill
        theme="snow"
        placeholder={placeHolder}
        value={input}
        onChange={setInput}
        modules={modules}
        formats={formats}
      />
      <div
        style={{ display: "flex", gap: "0.5rem", marginTop: "4rem" }}
        className="btn-quill"
      >
        <button type="submit" className="ok-btn">
          Save Changes
        </button>
        <button type="button" className="cancel-btn" onClick={handleCancel}>
          Cancel
        </button>
      </div>
    </form>
  );
};

export default CommentForm;
